<template>
  <div>
    <script id="editor" type="text/plain"></script>
  </div>
</template>

<script>
   export default{
     name: 'UE',
     data () {
       return {
         editor: null
       }
     },
     props: {
       value: {
         type: String
       },
       config: {
         type: Object
       }
     },
     mounted() {
       this.editor = UE.getEditor('editor', this.config); // 初始化UE
       this.editor.addListener("ready", this.setContents);
       this.editor.addListener("contentChange", this.changeContent)
     },
     methods: {
       changeContent(){
         let content = this.editor.getContent();
         this.$emit('input', content);
       },

       setContents(){
         this.editor.setContent(this.value); // 确保UE加载完成后，放入内容。
       }
     },
     beforeDestroy() {

       this.editor.destroy();
     }
   };
</script>




// WEBPACK FOOTER //
// src/views/Component/UE/index.vue?61406d0c